
(function ($) {
    "use strict";

    //first figure out which CSS3 properties to set..
    let prefixes = ["", "O", "ms", "Webkit", "Moz"];

    //using same idea as jquery transform plugin..
    let DivStyle = document.createElement('div').style;
    let css3Prefix = null;
    for (var i = 0, len = prefixes.length; i < len; i++) {
        if (prefixes[i] + "Transition" in DivStyle && prefixes[i] + "Transform" in DivStyle) {
            css3Prefix = prefixes[i];
            break;
        }
    }

    //get the transition ended event name for the css3Prefix..
    let transitionEndEvent;
    switch (css3Prefix) {
        case "O":
            transitionEndEvent = "otransitionend";
        break;
        case "ms":
            transitionEndEvent = "msTransitionEnd";
        break;
        case "Webkit":
            transitionEndEvent = "webkitTransitionEnd";
        break;
        default:
            transitionEndEvent = "transitionend";
    }

    let translateOpen = window.WebKitCSSMatrix && 'm11' in new WebKitCSSMatrix() ? "translate3d(0, " : "translate(0, ";
    let translateClose = window.WebKitCSSMatrix && 'm11' in new WebKitCSSMatrix() ? "px ,0)" : "px)";

    //all allowed characters
    //if the non-digit characters are at the end for some reason)..
    let allChars = '. - + 0 1 2 3 4 5 6 7 8 9 ,';
    let numeric  = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

    let shuffleArray = function (array) {

        let currentIndex = array.length,  randomIndex;

        // While there remain elements to shuffle.
        while (currentIndex !== 0) {

            // Pick a remaining element.
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            // And swap it with the current element.
            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }

        return array;
    };

    //checks that the given value makes sense to use..
    let checkValue = function (str) {
        //check there are no odd chars first..
        for (let i = 0, len = str.length; i < len; i++) {
            if (allChars.indexOf(str.charAt(i)) < 0) {
                $.error("numberAnimate plugin requires that value used only contain character in: \"" + allChars + "\"");
                return false;
            }
        }
        return true;
    };

    /**
     * Binds the given function onto the given jQuery array $el on the transitionEndEvent and unbinds it after execution.
     * Also handles the case where the event doesn't fire, in which case a timeout is used to ensure execution, which runs
     * after the given number of milliseconds plus an additional 100ms grace period.
     */
    let bindToTransitionEndForSingleRun = function ($el, funcToExec, maxMSTillTransitionEnd) {
        let firedFunc = false;
        let wrappedFunc = function () {
            funcToExec();
            firedFunc = true;
            $el.unbind(transitionEndEvent, wrappedFunc);
        };
        $el.bind(transitionEndEvent, wrappedFunc);
        setTimeout(function () {
            if (!firedFunc) wrappedFunc();
        }, maxMSTillTransitionEnd + 100);
    };

    //Given a div which holder a character, it shift it to the required character,
    //note, the givenholder div should be attached prior to calling this for the animation
    //to take effect..
    let shiftToChar = function ($holderDiv, character, shiftTime, insertChars) {

        let innerStyle = $holderDiv.children()[0].style;
        innerStyle[css3Prefix + 'Transition'] = "all " + shiftTime + "ms ease-in-out";

        let indexOfChar = insertChars.indexOf(character);
        let transformY;
        if (indexOfChar < 0 || /\s/.test(character)) {
            transformY = $holderDiv.height();
        } else {
            transformY = 0 - (indexOfChar / 2) * $holderDiv.height();
        }
        innerStyle[css3Prefix + 'Transform'] = translateOpen + transformY + translateClose;
    };

    //Function to create a new character wrapper div to wrap the given character
    //setting the holding div to have the given dimension and given "position".
    //You should attach the element returned by this function to the DOM straight
    //away in order for the animation to take effect..
    //The animationTimes is an array of milliseconds which defines: creation,
    //shift and remove times..
    let createDivForChar = function (character, height, width, position) {

        let creationTime = 100;
        let shiftTime = 1500;

        let holderDiv = $(document.createElement('i')).css({
            'height': height + 'px',
            'line-height': height + 'px',
            'overflow': 'hidden',
            'display': 'inline-block',
            'font-style': 'normal'
        }).attr("data-number-animate-pos", position).attr("data-number-animate-char", character);

        let insertChars = '. - + '+ shuffleArray(numeric).join(' ') +' ,';

        let innerDiv = $(document.createElement('font')).html(insertChars).css({
            'text-align': 'left',
            'display':'inline-block'
        });

        //fix annoying flickering for older webkit browsers..
        if (css3Prefix === 'Webkit')
            innerDiv[0].style['-webkit-backface-visibility'] = 'hidden';

        //initially show blank..
        innerDiv[0].style[css3Prefix + 'Transform'] =  translateOpen + height + translateClose;
        holderDiv.append(innerDiv);

        //animate to the correct character when finished animating creation if necessary..
        let shiftToCorrectChar = function () {
            shiftToChar(holderDiv, character, shiftTime, insertChars);
        };

        //shift if after creation and after attachment if animating..
        if (creationTime) {
            //bit of a hack - transition will only work if the element is attached to the DOM
            //so use a timeout to make this possible (no onattached event)..
            setTimeout(function () {
                bindToTransitionEndForSingleRun(holderDiv, shiftToCorrectChar, creationTime);
                let holderStyle = holderDiv[0].style;
                holderStyle[css3Prefix + 'Transition'] = "all " + creationTime + "ms ease-in-out";
                holderStyle.width = width + "px";
            }, 20);
        } else if (shiftTime) {
            setTimeout(shiftToCorrectChar, 20);
        } else {
            shiftToCorrectChar();
        }

        return holderDiv[0];
    };

    let methods = {
        init: function () {

            this.css({
                'display': 'inline-block',
            });

            $.each(this, function () {

                let $this = $(this);

                //get initial value and set it as data..
                let valueStr = $this.data('number').toString();
                if (!checkValue(valueStr)) return false;

                //get width of a single character (assume mono-spaced font)..
                $this.html("1");
                let characterHeight = $this.height();
                $this.attr("data-number-animate-characterHeight", characterHeight);
                $this.html("");

                //required to get things to line up..
                $this.css({
                    "vertical-align": "top",
                    "display": "inline-block",
                    "height": characterHeight + "px"
                });

                //we position things relative to the dot, so store it's position..
                let indexOfPoint = valueStr.indexOf(".");
                if (indexOfPoint < 0) indexOfPoint = valueStr.length;

                //add divs representing each character..
                let docFrag = document.createDocumentFragment();
                for (var i = 0, len = valueStr.length; i < len; i++) {
                    var character = valueStr.charAt(i);
                    $this.html(character);
                    let characterWidth = $this.width();
                    $this.attr("data-number-animate-characterHeight", characterHeight);
                    $this.html("");
                    //create the divs with zero animation time..
                    docFrag.appendChild(
                        createDivForChar(character, characterHeight, characterWidth, indexOfPoint - i)
                    );
                }

                $this.append(docFrag); //add in one go.

            });
        }
    };

    $.fn.numberAnimate = function (method) {
        // Method calling logic (adapted from http://docs.jquery.com/Plugins/Authoring)..
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' +  method + ' does not exist on jQuery.numberAnimate');
        }
    };

})(jQuery);
